export default __webpack_public_path__ + "static/media/icon-class.ea358a9f.svg";